export default __webpack_public_path__ + "static/media/avatar_cheshire_cat1.adad5e9c.mp3";